import Immutable from 'seamless-immutable';
import { createActions, createReducer } from 'reduxsauce';

/* Action types and creators */

export const { Types, Creators } = createActions({
  requestSelfInformations: [],
  successSelfInformations: [],
  failureSelfInformations: [],
  loggedOnWorkstation: [],
  holdingTicket: [],
  tokenValidated: [],
  tokenInvalidated: [],
  requestLogout: [],
  requestLogin: [],
  successLogin: [],
  requestLoginWorkstation: [],
  successLoginWorkstation: [],
  failureLoginWorkstation: [],
  requestTokenInformations: [],
  successTokenInformations: []
});

/* Reducer handlers */

const INITIAL_STATE = Immutable({
  data: {
    id: 0,
    callTicketDirectly: 'F',
    callTicketInWaitingTicketsScreen: 'F',
    receivePasswordsOnHold: 'F',
    name: '',
    login: '',
    userEvolutionType: 0,
    environmentName: 'Ambiente',
    workstation: {
      id: 0, name: 'Estação', number: 0, available: false
    },
    office: {
      id: 0, name: 'Estação', timeTicketReload: 30000
    },
    canSearchTicket: 'F',
    useCreditCardResource: false,
    status: 0,
    loggedOnWorkstation: false,
    hasTicket: false,
    token: null,
    hasValidToken: null
  },
  loading: false,
  error: false
});

const requestSelfInformations = (state = INITIAL_STATE) =>
  ({ ...state, loading: true, error: false });

const successSelfInformations = (state = INITIAL_STATE, action) => {
  const { data } = state;

  return {
    ...state,
    loading: false,
    error: false,
    data: {
      ...data,
      ...action.payload
    }
  };
};

const failureSelfInformations = (state = INITIAL_STATE) =>
  ({ ...state, loading: false, error: true });

const holdingTicket = (state = INITIAL_STATE, action) => {
  const { data } = state;

  return {
    ...state,
    data: {
      ...data,
      hasTicket: action.payload
    }
  };
};

const tokenValidated = (state = INITIAL_STATE, action) => {
  const { data } = state;

  return {
    ...state,
    data: {
      ...data,
      token: action.payload
    }
  };
};

const successLogin = (state = INITIAL_STATE) =>
  ({ ...state, data: { ...state.data, hasValidToken: true } });

const tokenInvalidated = () => {
  const state = { ...INITIAL_STATE };
  const { data } = state;

  return ({
    ...INITIAL_STATE,
    data: {
      ...data,
      token: null,
      hasValidToken: false
    }
  });
};

const requestLoginWorkstation = (state = INITIAL_STATE) =>
  ({ ...state, loading: true, error: false });

const successLoginWorkstation = (state = INITIAL_STATE, action) => {
  const { data } = state;

  return {
    ...state,
    data: {
      ...data,
      workstation: { ...action.payload.workstation },
      environmentName: action.payload.environmentName,
      loggedOnWorkstation: true
    }
  };
};

const failureLoginWorkstation = (state = INITIAL_STATE) =>
  ({ ...state, loading: false, error: true });

const successTokenInformations = (state = INITIAL_STATE, action) => {
  const { data } = state;

  return {
    ...state,
    data: {
      ...data,
      token: action.payload.token,
      hasValidToken: action.payload.hasValidToken
    }
  };
};

export default createReducer(INITIAL_STATE, {
  [Types.REQUEST_SELF_INFORMATIONS]: requestSelfInformations,
  [Types.SUCCESS_SELF_INFORMATIONS]: successSelfInformations,
  [Types.FAILURE_SELF_INFORMATIONS]: failureSelfInformations,
  [Types.HOLDING_TICKET]: holdingTicket,
  [Types.TOKEN_VALIDATED]: tokenValidated,
  [Types.TOKEN_INVALIDATED]: tokenInvalidated,
  [Types.REQUEST_LOGIN_WORKSTATION]: requestLoginWorkstation,
  [Types.SUCCESS_LOGIN_WORKSTATION]: successLoginWorkstation,
  [Types.FAILURE_LOGIN_WORKSTATION]: failureLoginWorkstation,
  [Types.SUCCESS_LOGIN]: successLogin,
  [Types.SUCCESS_TOKEN_INFORMATIONS]: successTokenInformations,
});
